'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollSync = undefined;

var _ScrollSync = require('./ScrollSync');

var _ScrollSync2 = _interopRequireDefault(_ScrollSync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ScrollSync2.default;
exports.ScrollSync = _ScrollSync2.default;